import { render, staticRenderFns } from "./MobileChatHeader.vue?vue&type=template&id=c7ca183a&scoped=true"
import script from "./MobileChatHeader.vue?vue&type=script&lang=js"
export * from "./MobileChatHeader.vue?vue&type=script&lang=js"
import style0 from "./MobileChatHeader.vue?vue&type=style&index=0&id=c7ca183a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ca183a",
  null
  
)

export default component.exports